import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import WInput from "@/components/form/w-input.vue";
import axios from "axios";
import { alertError } from "@/util/dialog";
import Loader from "@/components/loader/Loader.vue";
import LightButton from "@/components/buttons/LightButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import { v4 as uuidv4 } from 'uuid';
import { AiSpeachGenerationFile } from "@/models/aiSpeachGenerator.models";
import AIChapterContentGenerator from "@/components/aiSpeachGenerator/AIChapterContentGenerator.vue";
import { Events } from "@/events/events";
let AIChapterContentGeneratorInitiator = class AIChapterContentGeneratorInitiator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "weetEndpoint", void 0);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "indexLecon", void 0);
    _defineProperty(this, "indexChapter", void 0);
    _defineProperty(this, "chapitreId", void 0);
    _defineProperty(this, "chapitreIdMap", void 0);
    _defineProperty(this, "speachGenerated", void 0);
    _defineProperty(this, "speachToMap", void 0);
    _defineProperty(this, "aiFiles", []);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "loadingInterface", true);
  }
  async mounted() {
    this.loadingInterface = true;
    await this.restoreSpeachGenerated();
    await this.restoreSpeachToMap();
    await this.restoreAiFiles();
    this.loadingInterface = false;
  }
  async restoreSpeachGenerated() {
    try {
      const response = await axios.get(`/recorder/aiSpeachGenerator/restoreAISpeach/` + this.speachId);
      if (response.data) {
        this.speachGenerated = response.data;
      }
    } catch (error) {
      console.error('Error fetching speach generated data:', error);
      alertError('Failed to restore AI speech data');
    }
  }
  async restoreSpeachToMap() {
    try {
      const response = await axios.get(`/recorder/aiSpeachGenerator/restoreSpeachToMap/` + this.speachId);
      if (response.data) {
        this.speachToMap = response.data;
      }
    } catch (error) {
      console.error('Error fetching speech details data:', error);
      alertError('Failed to restore speach mapping data');
    }
  }
  getSubChapter() {
    if (this.chapitreIdMap) {
      for (const chapter of this.speachGenerated.chapters) {
        for (const subChapter of chapter.subchapters) {
          if (subChapter.chapterID === this.chapitreIdMap) {
            return subChapter;
          }
        }
      }
    }
    return this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter];
  }
  async restoreAiFiles() {
    // Get chapters
    const subChapter = this.getSubChapter();
    const listOfDocumentPage = subChapter.documentPages;
    try {
      for (const page of listOfDocumentPage) {
        const response = await axios.get(`/recorder/aiSpeachGenerator/restoreAIFile/${this.speachId}/${page.jobID}`);
        if (response.data) {
          const aiFile = new AiSpeachGenerationFile(uuidv4(), page.jobID, page.documentName, response.data);
          this.aiFiles.push(aiFile);
        }
      }
    } catch (error) {
      console.error('Error fetching AI files:', error);
      alertError('Failed to restore generation files');
      this.aiFiles = [];
    }
  }
  finishEditing(speachID) {
    if (speachID) {
      trig(Events.AFFICHER_EDITION_CHAPITRE, {
        id: this.chapitreId
      });
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE);
    } else {
      trig(Events.AFFICHER_CHOIX_TYPE_CHAPITRE, this.chapitreId);
      this.loadingInterface = true;
    }
  }
};
__decorate([Prop({
  required: true
})], AIChapterContentGeneratorInitiator.prototype, "weetEndpoint", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGeneratorInitiator.prototype, "speachId", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGeneratorInitiator.prototype, "indexLecon", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGeneratorInitiator.prototype, "indexChapter", void 0);
__decorate([Prop({
  required: true
})], AIChapterContentGeneratorInitiator.prototype, "chapitreId", void 0);
__decorate([Prop({
  required: false,
  default: ""
})], AIChapterContentGeneratorInitiator.prototype, "chapitreIdMap", void 0);
AIChapterContentGeneratorInitiator = __decorate([Component({
  components: {
    AIChapterContentGenerator,
    WDialog,
    IconButton,
    LightButton,
    Loader,
    WInput,
    BigButton,
    StandardButton,
    Icon
  }
})], AIChapterContentGeneratorInitiator);
export default AIChapterContentGeneratorInitiator;